import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EditOrganizerV1, QK } from 'ck-queries';
import { createFormData, fetchWithErrorThrowing } from 'ck-utils';
import toast from 'react-hot-toast';

export const useEditOrganizer = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: EditOrganizerV1) =>
      toast.promise(putEditOrganizer(id, data), {
        loading: 'Laddar...',
        success: 'Arrangören har uppdaterats',
        error: 'Kunde inte uppdatera arrangören',
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries([QK.organizers, id]);
    },
  });
};

async function putEditOrganizer(id: string, data: EditOrganizerV1) {
  const { links, ...rest } = data;
  const formData = createFormData(rest);

  // Appended by hand because createFormData omits the index for arrays of objects
  // (`links[label]` for every item), which collides label/url across items. ASP.NET's
  // form binder needs the index to build the collection: without `links[0].label` it
  // binds an empty list, and the backend then nulls every link column.
  links.forEach((link, index) => {
    formData.append(`links[${index}].label`, link.label);
    formData.append(`links[${index}].url`, link.url);
  });

  return fetchWithErrorThrowing(`/organizer-pages/${id}`, {
    method: 'PUT',
    body: formData,
  });
}
